import * as AuthTypes from './types';

export const initialAuthState: AuthTypes.AuthState = Object.freeze({
  username: null,
  token: null,
  refresh_token: null,
  userHasBeenSwitched: false,
  error: false,
  pending: false,
  initializing: true,
});

const authReducer = (state: AuthTypes.AuthState, action: AuthTypes.AuthReducerAction) => {
  switch (action.type) {
    case AuthTypes.AuthenticationProviderActionTypes.START: {
      return {
        ...state,
        pending: true,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.LOGIN: {
      const { username, token, refresh_token, userHasBeenSwitched } = action.payload;

      return {
        ...state,
        username,
        token,
        refresh_token,
        userHasBeenSwitched,
        error: false,
        pending: false,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.SOCIAL_LOGIN: {
      const { username, token, refresh_token } = action.payload;

      return {
        ...state,
        username,
        token,
        refresh_token,
        error: false,
        pending: false,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.LOGOUT: {
      return {
        ...state,
        username: null,
        token: null,
        refresh_token: null,
        userHasBeenSwitched: false,
        error: false,
        pending: false,
        userData: undefined,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.ERROR: {
      return {
        ...state,
        username: null,
        token: null,
        refresh_token: null,
        userHasBeenSwitched: false,
        error: action.payload.status === 401 ? 'authError' : 'genericError',
        pending: false,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.RESET: {
      return {
        ...initialAuthState,
        initializing: false,
        userData: undefined,
        ...action.payload,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.PREFERENCES: {
      return {
        ...state,
        preferences: action.payload,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.USER_DATA: {
      return {
        ...state,
        userData: action.payload,
      };
    }

    case AuthTypes.AuthenticationProviderActionTypes.RELOAD: {
      return {
        ...state,
        initializing: true,
      };
    }

    default: {
      throw new Error('Unknown action dispatched to authReducer');
    }
  }
};

export default authReducer;
